import { render } from "./GameTeams.vue?vue&type=template&id=664c5e79&scoped=true"
import script from "./GameTeams.vue?vue&type=script&lang=js"
export * from "./GameTeams.vue?vue&type=script&lang=js"

import "./GameTeams.vue?vue&type=style&index=0&id=664c5e79&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664c5e79"]])

export default __exports__